import { ETier } from "../enums";

export const getFeeByTier = (tier?: string): number => {
  switch (tier) {
    case ETier.ALPHA:
      return 0;
    case ETier.BETA:
      return 0.0025;
    case ETier.GAMMA:
      return 0.005;
    case ETier.BEGINNER:
      return 0.01;
    default:
      return 0.015;
  }
};
